import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from "@angular/router";
import { ChatFullscreenService } from "./chat-fullscreen.service";
import { SignalrService } from "app/signalr.service";
import { of } from "rxjs";
import { ChatService } from "../chat.service";

@Injectable({
    providedIn: "root"
})
export class ChatFullscreenResolver implements Resolve<any> {

    constructor(
        private _router: Router,
        private _chatFullscreenService: ChatFullscreenService,
        private _signalRService: SignalrService,
        private _chatService: ChatService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        const catalogo = route.queryParamMap.get('id');
        const mensagemGuid = route.queryParamMap.get('message');

        if (!mensagemGuid || !catalogo) {
            return this._router.createUrlTree(['/empty-state']);
        }

        this.limparStorage();

        return this._chatFullscreenService.validaParticipante(mensagemGuid, catalogo);
    }

    private limparStorage(): void {
        this._signalRService.guid = "";
        this._signalRService.mensagemIniciada = false;
        this._signalRService.pergunta = false;
        this._signalRService.token = "";
        this._signalRService.chatId = "";
        this._signalRService.chaveSignalR = "";
        this._chatService.menssagemPersistidas = "";
    }
}